import { ArrowLeft, Presentation, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function SowiftPresentations() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 flex flex-col min-h-0">
      {/* Header */}
      <div className="shrink-0 p-6 border-b border-border-primary">
        <button
          onClick={() => navigate("/apps/sowift")}
          className="flex items-center gap-2 text-sm text-content-tertiary hover:text-content-primary transition-colors mb-4"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to SoWift
        </button>
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-linear-to-br from-mutual-orange/20 to-mutual-purple/20 flex items-center justify-center">
            <Presentation className="h-5 w-5 text-brand-primary" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-content-primary">Presentations</h1>
            <p className="text-content-tertiary mt-0.5 text-sm">AI-powered client presentations from project data</p>
          </div>
        </div>
      </div>

      {/* Coming Soon Content */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="text-center max-w-md">
          <div className="h-20 w-20 rounded-2xl bg-linear-to-br from-mutual-orange/10 to-mutual-purple/10 border border-border-primary flex items-center justify-center mx-auto mb-6">
            <Sparkles className="h-10 w-10 text-brand-primary/60" />
          </div>
          <h2 className="text-xl font-semibold text-content-primary mb-2">Coming Soon</h2>
          <p className="text-content-tertiary leading-relaxed">
            Generate compelling client presentations directly from your SoWift projects. AI-assisted slide creation,
            branded templates, and one-click PPTX export.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            {["Slide Generation", "Branded Templates", "PPTX Export", "Data Visualization", "Speaker Notes"].map(
              (feature) => (
                <span
                  key={feature}
                  className="px-3 py-1.5 rounded-full text-xs font-medium bg-surface-secondary text-content-tertiary border border-border-secondary"
                >
                  {feature}
                </span>
              ),
            )}
          </div>
          <p className="text-content-quaternary text-xs mt-6">
            We're actively building this feature. Stay tuned for updates.
          </p>
        </div>
      </div>
    </div>
  );
}
